import DirectDownloadActionTypes from 'redux/direct-download/types';

const INITIAL_STATE = {
  downloadIds: [],
  taskProgress: {},
  lastExportStatus: null,
  exportMonitor: {
    active: false,
    minimized: false,
    label: 'Applicant export',
  },
  querying: false,
  error: null,
};

function DirectDownloadReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case DirectDownloadActionTypes.SAVE_DOWNLOAD_IDS:
      return {
        ...state,
        downloadIds: [...state.downloadIds, payload],
        taskProgress: {
          ...state.taskProgress,
          [payload.id]: {
            progress: 0,
            complete: false,
            error: null,
          },
        },
        lastExportStatus: {
          id: payload.id,
          progress: 0,
          complete: false,
          error: null,
        },
        exportMonitor: {
          active: true,
          minimized: state.exportMonitor?.minimized || false,
          label: state.exportMonitor?.label || 'Applicant export',
        },
      };

    case DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_START:
      return {
        ...state,
        querying: true,
      };
    case DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_SUCCESS:
      return {
        ...state,
        querying: false,
      };
    case DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_FAILED:
      return {
        ...state,
        querying: false,
        error: payload,
      };

    case DirectDownloadActionTypes.UPDATE_DOWNLOAD_IDS:
      return {
        ...state,
        downloadIds: payload,
      };

    case DirectDownloadActionTypes.UPDATE_DOWNLOAD_PROGRESS: {
      const nextProgress = { ...state.taskProgress };
      let lastExportStatus = state.lastExportStatus;

      (payload || []).forEach((task) => {
        if (!task?.id) return;
        const status = {
          id: task.id,
          progress: typeof task.progress === 'number' ? task.progress : 0,
          complete: Boolean(task.complete),
          error: task.error || null,
        };
        nextProgress[task.id] = status;
        lastExportStatus = status;
      });

      const hasError = (payload || []).some((task) => Boolean(task?.error));

      return {
        ...state,
        taskProgress: nextProgress,
        lastExportStatus,
        exportMonitor: hasError
          ? {
              ...state.exportMonitor,
              active: true,
              minimized: false,
            }
          : state.exportMonitor,
      };
    }

    case DirectDownloadActionTypes.SET_EXPORT_MONITOR:
      return {
        ...state,
        exportMonitor: {
          ...state.exportMonitor,
          ...payload,
          active: true,
        },
      };

    case DirectDownloadActionTypes.MINIMIZE_EXPORT_MONITOR:
      return {
        ...state,
        exportMonitor: {
          ...state.exportMonitor,
          active: true,
          minimized: true,
        },
      };

    case DirectDownloadActionTypes.EXPAND_EXPORT_MONITOR:
      return {
        ...state,
        exportMonitor: {
          ...state.exportMonitor,
          active: true,
          minimized: false,
        },
      };

    case DirectDownloadActionTypes.DISMISS_EXPORT_MONITOR:
      return {
        ...state,
        exportMonitor: {
          active: false,
          minimized: false,
          label: 'Applicant export',
        },
        lastExportStatus: null,
      };

    default:
      return state;
  }
}

export default DirectDownloadReducer;
